import { catchError, throwError } from 'rxjs';

import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';

import { ErrorStateService } from '@/app/core/services/error-state.service';

export const ErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const errorStateService = inject(ErrorStateService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        errorStateService.setError(error);
      }

      return throwError(() => error);
    }),
  );
};
